module.exports = function(post) {
	"use strict";
  post
  .directive('sortableGalleryDir',sortableGalleryDir);
	sortableGalleryDir.$inject = ['refreshtokenService','postDataService','$rootScope','alertService','serverError','offlineError'];
  function sortableGalleryDir(refreshtokenService,postDataService,$rootScope,alertService,serverError,offlineError) {
    return {
      require: '?ngModel',
      link: function(scope, element, attrs, ngModel) {
        var state = 'attachments';
        // scope.$watch(function(){
        //   return ngModel.$modelValue
        // }, function(newValue, oldValue){
        //   if (newValue!=oldValue) {
        //     for (var i=0; i<ngModel.$modelValue.length;i++) {
        //       ngModel.$modelValue[i].index = i;
        //     }
        //   }
        // },true);
        var options = {
          helper:'original',
          axis:'y,x',
          start: function(e, ui) {
            ui.item.directive = {
              start: ui.item.index(),
              startModel: ngModel
            };
          },
          update: function(e, ui) {
            var start = ui.item.directive.start;
            var end = ui.item.index();
            
            if (ui.item.closest('.ui-sortable')[0] === element[0]) {
              scope.$apply(function() {
                var element = ui.item.directive.startModel.$modelValue.splice(start, 1)[0];
                ngModel.$modelValue.splice(end, 0, element);
              });
            }
            console.log(ngModel);

            scope.$apply(function() {
              var postOrderFunction = function() {
                $rootScope.hasLoaded = false;
                scope.galleryOrderArray = [];
                for(var i=0;i<ngModel.$modelValue.length;i++) {
                  scope.galleryOrderArray.push({'_id':ngModel.$modelValue[i]._id,'order':i+1});
                } 
                  postDataService.save({
                      param1:state,
                      param2:'reorder'
                    },{
                      'new_order': scope.galleryOrderArray
                    }).$promise.then(function(data){
                      $rootScope.hasLoaded = true;
                        alertService('success','Success ', data.message, 2000);
                    }, function(error){
                      if(!window.navigator.onLine) {
                        offlineError()
                        $rootScope.hasLoaded = true;
                        alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                        return
                      }
                      if(error.status ==401) {
                        var promise = refreshtokenService.getAccessToken();
                        promise.then(
                          function(answer) {
                            if(answer==200) {
                              postOrderFunction();
                            }
                          },
                          function(error) {
                            // report something
                          },
                          function(progress) {
                           // report progress
                        });
                      } else if(error.status ==502) {
                        serverError()
                      } else {
                        alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                      }
                      $rootScope.hasLoaded = true;
                    });
                }
              postOrderFunction()
            })
          }
        };
        element.sortable(options);
      }
    };
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/sortableImageGalleryDirective.js
// module id = 566
// module chunks = 0